import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { cachedSerialNames31jc5fovi62px as cachedSerialNames } from './Platform.common.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from '../descriptors/SerialDescriptor.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from './CachedNames.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var NullableSerializerClass;
function NullableSerializer() {
  if (NullableSerializerClass === VOID) {
    class $ {
      constructor(serializer) {
        this.h20_1 = serializer;
        this.i20_1 = new (SerialDescriptorForNullable())(this.h20_1.a1n());
      }
      a1n() {
        return this.i20_1;
      }
      j20(encoder, value) {
        if (!(value == null)) {
          encoder.n1t();
          encoder.k1t(this.h20_1, value);
        } else {
          encoder.n1s();
        }
      }
      b1n(encoder, value) {
        return this.j20(encoder, value);
      }
      c1n(decoder) {
        return decoder.c1r() ? decoder.q1r(this.h20_1) : decoder.d1r();
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof NullableSerializer()))
          THROW_CCE();
        if (!equals(this.h20_1, other.h20_1))
          return false;
        return true;
      }
      hashCode() {
        return hashCode(this.h20_1);
      }
    }
    initMetadataForClass($, 'NullableSerializer', VOID, VOID, [KSerializer()]);
    NullableSerializerClass = $;
  }
  return NullableSerializerClass;
}
var SerialDescriptorForNullableClass;
function SerialDescriptorForNullable() {
  if (SerialDescriptorForNullableClass === VOID) {
    class $ {
      constructor(original) {
        this.q1p_1 = original;
        this.r1p_1 = this.q1p_1.d1o() + '?';
        this.s1p_1 = cachedSerialNames(this.q1p_1);
      }
      d1o() {
        return this.r1p_1;
      }
      a1r() {
        return this.s1p_1;
      }
      p1p() {
        return true;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SerialDescriptorForNullable()))
          return false;
        if (!equals(this.q1p_1, other.q1p_1))
          return false;
        return true;
      }
      toString() {
        return toString(this.q1p_1) + '?';
      }
      hashCode() {
        return imul(hashCode(this.q1p_1), 31);
      }
      w1p() {
        return this.q1p_1.w1p();
      }
      x1p() {
        return this.q1p_1.x1p();
      }
      y1p() {
        return this.q1p_1.y1p();
      }
      z1p() {
        return this.q1p_1.z1p();
      }
      a1q(index) {
        return this.q1p_1.a1q(index);
      }
      b1q(name) {
        return this.q1p_1.b1q(name);
      }
      c1q(index) {
        return this.q1p_1.c1q(index);
      }
      d1q(index) {
        return this.q1p_1.d1q(index);
      }
      e1q(index) {
        return this.q1p_1.e1q(index);
      }
    }
    initMetadataForClass($, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    SerialDescriptorForNullableClass = $;
  }
  return SerialDescriptorForNullableClass;
}
//region block: exports
export {
  NullableSerializer as NullableSerializer41etqlj0tdq5,
  SerialDescriptorForNullable as SerialDescriptorForNullable2slcv65za9oog,
};
//endregion

//# sourceMappingURL=NullableSerializer.mjs.map
